import { useEffect, useState } from 'react';
export const useMountTransition = (active, transitionDuration) => {
    const [visible, setVisible] = useState(false);
    const [render, setRender] = useState(false);
    useEffect(() => {
        let raf1;
        let raf2;
        let hideTimeout;
        if (active) {
            setRender(true);
            raf1 = requestAnimationFrame(() => raf2 = requestAnimationFrame(() => setVisible(true)));
        }
        else {
            setVisible(false);
            hideTimeout = setTimeout(() => setRender(false), transitionDuration);
        }
        return () => {
            cancelAnimationFrame(raf1);
            cancelAnimationFrame(raf2);
            clearTimeout(hideTimeout);
            setRender(active);
            setVisible(active);
        };
    }, [active, transitionDuration]);
    return [render, visible];
};
export default useMountTransition;
